const Keys = [
  'dataCulture',
  'selectedCountries',
  'includeProductsMissingAvailableCountries',
  'translationLanguage',
  'selected-product-type',
  'product-activateFilterLinks',
  'product-enabledTemplates',
  'product-hideEmptyProperties',
  'product-selectedProperties',
  'product-visibilityFilter',
  'productsArchive-view',
  'productsArchive-sideMenuCollapsed',
  'product-showColouredDeadlineHeaders',
  'product-selectedPropertyDeadlines',
  'productTable-enabledTemplates',
  'productTable-selectedProperties',
  'productTable-activateFilterLinks',
  'productTable-columnSizes',
  'productTable-selectedCultures',
  'productTable-textareaStyle',
  'productTable-copiedData',
  'productTable-selectedCulturesFollowIncludedCountries',
  'productTable-showColouredDeadlineHeaders',
  'productTable-selectedPropertyDeadlines',
  'productTable-searchWindowPosition',
  'customFilters',
  'discreet-availability-status',
  'productsFilter-addMultipleSearchTerms',
  'logs-formatting',
  'filter-searchTextareaHeight',
  'seen-clipboard-read-error',
] as const

type StorageKey = (typeof Keys)[number]
type Storage = 'both' | 'localStorage' | 'sessionStorage'

export const browserStorage = {
  keys: Keys,

  /**
   * sets local storage and/or session storage
   */
  set: (key: StorageKey, data: any, storage: Storage = 'both') => {
    if (data instanceof Set) {
      data = Array.from(data)
    }

    if (storage === 'both') {
      localStorage.setItem(key, JSON.stringify(data))
      sessionStorage.setItem(key, JSON.stringify(data))
    } else {
      window[storage].setItem(key, JSON.stringify(data))
    }
  },

  /**
   * as default fetches first hand from session storage, secondly from local storage, or if storage is specified
   * (enables a global browser save, while still allowing open tabs to keep their own setting)
   */
  get: <T = any>(key: StorageKey, storage: Storage = 'both', onFailCallback?: () => void) => {
    const data = storage === 'both' ? sessionStorage.getItem(key) || localStorage.getItem(key) : window[storage].getItem(key)

    try {
      if (data) {
        return JSON.parse(data) as T
      }
    } catch (err) {
      console.log(`browserStorage encountered parsing error using key ${key}`, err)
      onFailCallback?.()
    }
  },

  delete: (key: StorageKey) => {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  },
}
